// API timestamps are UTC wall times, same as formatDateTimeToLocal (space -> T, then Z).
export function isCurrentAssignment(item, now = new Date()) {
  const toUtc = (value) => {
    if (value == null || value === '') return null
    const date = new Date(String(value).replace(' ', 'T') + 'Z')
    return Number.isNaN(date.getTime()) ? null : date
  }
  const start = toUtc(item && item.startDate)
  if (start && start > now) return false
  if (!item || item.endDate == null || item.endDate === '') return true
  const end = toUtc(item.endDate)
  if (!end) return false
  return end > now
}
